import * as React from 'react';
export const LazyUncontrolledRecipientWell = React.lazy(() =>
    import(/* webpackChunkName: "UncontrolledRecipientWell", webpackPrefetch: false */ 'owa-readwrite-recipient-well-fabric/lib/components/UncontrolledRecipientWell')
);
